<template>
  <v-container class="home-wrapper">
    <v-img
      :src="require('@/assets/home/banner.jpg')"
      class="rounded-xl pointer"
      width="100vw"
      contain
      @click="openClient()"
    >
    </v-img>

    <section class="my-8 my-md-16">
      <div class="d-flex align-center justify-center mb-4">
        <v-divider class="mini-divider" />

        <div
          class="text-h5 text-md-h4 font-weight-bold primary--text bebas-neue mx-2"
        >
          PARTICIPE
        </div>

        <v-divider class="mini-divider" />
      </div>

      <div
        class="text-h5 text-md-h4 font-weight-bold text-center russo-one mb-8 mb-md-16"
      >
        SORTEIO DISPONÍVEL,<br />
        LANCE SUA SORTE
      </div>

      <v-card
        class="card pb-0 pb-md-8 background-current"
        color="neutral2"
        outlined
      >
        <v-row align="center" justify="space-around" no-gutters>
          <v-col cols="12" md="5">
            <v-card class="card glass-container" flat>
              <div class="d-flex align-center flex-column text-center relative">
                <div
                  v-if="currentRaffle?.awards?.cash > 1000"
                  class="white--text blue text-h5 font-weight-black px-2 mb-2 absolute accumulated"
                >
                  ACUMULOU
                </div>

                <div class="d-flex justify-end fill-width mb-2">
                  <v-chip
                    class="neutral--text text-h5 font-weight-black"
                    color="primary"
                    label
                  >
                    HOJE
                  </v-chip>
                </div>

                <div class="text-h2 font-weight-black mb-4">
                  <span class="text-h4 font-weight-black">R$</span>
                  {{ currencyMask(currentRaffle?.awards?.cash || 0) }}
                </div>

                <section v-if="timeRemaining !== '00:00:00'">
                  <div class="text-h6 font-weight-regular neutral8--text mb-2">
                    Tempo restante
                  </div>

                  <v-card class="card-timer rounded-lg px-4 py-2 mb-8" flat>
                    <div class="text-h4 font-weight-bold">
                      {{ timeRemaining }}
                    </div>
                  </v-card>
                </section>

                <v-btn
                  class="btn pulse"
                  color="primary"
                  x-large
                  rounded
                  @click="openClient()"
                >
                  <span class="neutral--text font-weight-bold">
                    QUERO PARTICIPAR
                  </span>
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="5" xl="4" class="relative">
            <v-img
              class="control-image"
              :class="{ absolute: $vuetify.breakpoint.mdAndUp }"
              :src="require('@/assets/home/control2.png')"
            />
          </v-col>
        </v-row>
      </v-card>
    </section>

    <section class="my-8 my-md-16">
      <div class="d-flex align-center justify-center mb-4">
        <v-divider class="mini-divider" />

        <div
          class="text-h5 text-md-h4 font-weight-bold primary--text bebas-neue mx-2"
        >
          CONFIRA
        </div>

        <v-divider class="mini-divider" />
      </div>

      <div
        class="text-h5 text-md-h4 font-weight-bold text-center russo-one mb-8 mb-md-16"
      >
        ACOMPANHE OS RESULTADOS,<br />
        A SORTE FOI LANÇADA
      </div>

      <loader v-if="loading.raffles" />

      <section v-else>
        <v-row class="mb-6">
          <v-col v-for="(item, i) in raffles" :key="i" cols="12" md="6">
            <RaffleCard :raffle="item" />
          </v-col>
        </v-row>

        <div class="d-flex justify-center">
          <v-btn class="btn pulse" color="primary" :href="_clientURL" large>
            Veja mais
          </v-btn>
        </div>
      </section>
    </section>

    <section class="my-8 my-md-16">
      <div
        class="text-h5 text-md-h4 font-weight-bold text-center russo-one text-header"
      >
        ACERTE A
        <span class="primary--text">PALAVRA </span>
        <span class="secondary--text">PREMIADA</span>
        DO DIA E CONCORRA A PRÊMIOS DIÁRIOS
      </div>
    </section>

    <v-card class="card rounded-xl" color="neutral2" outlined>
      <v-row justify="center" align="center">
        <!-- <v-col cols="7" md="5">
          <div class="d-flex align-center justify-center">
            <v-icon size="15rem" color="neutral5"> fas fa-user-shield </v-icon>
          </div>
        </v-col> -->

        <v-col cols="12" class="text-body-1 neutral9--text">
          <div class="text-h6 font-weight-black text1--text mb-4">
            Transparência nos Sorteios
          </div>

          <p>
            Na <strong>Palavra Premiada</strong>, levamos a transparência muito
            a sério. Por isso, nossos sorteios diários são realizados por um
            serviço externo, confiável e imparcial: o
            <a href="https://www.random.org/" target="_blank">random.org</a>.
          </p>

          <h3 class="mb-2">🎲 Como funciona o sorteio?</h3>

          <p>
            Todos os dias, exatamente à meia-noite (00:00), um número aleatório
            entre <strong>000000</strong> e <strong>999999</strong> é gerado
            através da plataforma
            <a href="https://www.random.org/" target="_blank">random.org</a>.
          </p>

          <p>Esse número representa o número vencedor do sorteio do dia.</p>

          <p>
            O processo é <strong>100% automatizado</strong> e não pode ser
            manipulado manualmente.
          </p>

          <p>
            O número sorteado é registrado em tempo real em nossa plataforma e
            disponibilizado nesta página, com data e horário.
          </p>

          <h3 class="mb-2">
            ✅ Por que usamos o
            <a href="https://www.random.org/" target="_blank">random.org</a>?
          </h3>

          <p>
            Diferente de métodos comuns de aleatoriedade baseados em código
            (como os que usam <code>math.random()</code>), o
            <a href="https://www.random.org/" target="_blank">random.org</a>.
            utiliza <strong>ruído atmosférico</strong> para gerar os números,
            garantindo aleatoriedade real e imparcialidade comprovada.
          </p>

          <h3 class="mb-2">Histórico dos Sorteios</h3>

          <p class="mb-0">
            🔍 Você pode conferir o número sorteado de cada dia logo no próprio
            sorteio, com histórico completo.
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { getRaffles } from "@/services/raffles";
import { currencyMask, calculateTimeRemaining } from "@/helpers";
import RaffleCard from "@/components/raffleCard/RaffleCard.vue";

export default {
  name: "Home",

  components: {
    RaffleCard,
  },

  data() {
    return {
      timer: null,
      interval: null,
      loading: {
        raffles: true,
      },
      timeRemaining: "--:--:--",
      currentRaffle: null,
      waitingResult: false,
      raffles: [],
    };
  },

  beforeMount() {
    this.getData();
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.interval) clearInterval(this.interval);
  },

  computed: {
    _clientURL() {
      return process.env.VUE_APP_CLIENT_URL;
    },
  },

  methods: {
    getData() {
      this.getOpenRaffles();
      this.getRaffles();
    },

    async getOpenRaffles() {
      try {
        const payload = {
          status: ["open"],
        };

        const { data } = await getRaffles(payload);

        if (!data.length) return;

        if (data[0]._id !== this.currentRaffle?._id) {
          if (this.interval) clearInterval(this.interval);
          this.startTimer(data[0].endDate);
        }

        this.currentRaffle = data[0];
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async getRaffles() {
      try {
        const payload = {
          limit: 4,
          offset: 0,
          status: ["finished"],
        };

        const { data } = await getRaffles(payload);

        this.raffles = data;
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.raffles = false;
      }
    },

    startTimer(endDate) {
      if (this.timer) clearInterval(this.timer);

      this.calculateTimeRemaining(endDate);

      this.timer = setInterval(() => {
        this.calculateTimeRemaining(endDate);
      }, 1000);
    },

    calculateTimeRemaining(endDate) {
      this.timeRemaining = calculateTimeRemaining(endDate);

      if (this.timeRemaining === "00:00:00") {
        this.waitingResult = true;
        clearInterval(this.timer);

        this.handleRaffleInterval();
      }
    },

    handleRaffleInterval() {
      this.interval = setInterval(() => {
        this.getData();
      }, 10000);
    },

    openClient() {
      window.location.href = process.env.VUE_APP_CLIENT_URL;
    },

    currencyMask,
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
